module.exports = __webpack_public_path__ + "img/3.4cb4008c.svg";